// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"31d6cfe0","666":"32cf4a1d"}[chunkId] + ".chunk.css";
};